import { render, staticRenderFns } from "./updateEmployeeProfile.vue?vue&type=template&id=62ffbcc2&scoped=true"
import script from "./updateEmployeeProfile.vue?vue&type=script&lang=js"
export * from "./updateEmployeeProfile.vue?vue&type=script&lang=js"
import style0 from "./updateEmployeeProfile.vue?vue&type=style&index=0&id=62ffbcc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ffbcc2",
  null
  
)

export default component.exports